module.exports = __webpack_public_path__ + "img/reserve.95997ba2.png";